import {Dialog, DialogContent, makeStyles} from '@material-ui/core';
import React, {useEffect, useState} from 'react';
import MessagesConversation from './../Messages/MessagesConversation';
import './.././Messages/MessagesConversation.scss';
import {UserModelMapper} from '@shared/services/service-mappers/ModelMapper';
import {getClinicUsersList} from '@shared/services/ClinicServices';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';
import {useSnackbar} from 'notistack';

const useStyles = makeStyles(() => ({
  wrapper: {
    '& .MuiDialogContent-root': {
      padding: '0.2rem',
      overflow: 'hidden'
    }
  },
  dialogContentWrapper: {
    display: 'flex'
  }
}));
interface MessagesDialogProps {
  groupId: number;
  clinicId: number;
  guarantorId: number;
  handleClose: () => void;
  showConversation: boolean;
  messageId: number;
  defaultEventType?: string | null;
}
const MessagesConversationDialog = (
  props: MessagesDialogProps
): React.ReactElement => {
  const {
    groupId,
    clinicId,
    handleClose,
    showConversation,
    messageId,
    guarantorId,
    defaultEventType
  } = props;
  const classes = useStyles();
  const [groupUsersList, setGroupUsersList] = useState<Array<UserModelMapper>>(
    []
  );
  const {enqueueSnackbar} = useSnackbar();

  useEffect(() => {
    const fetchClinicUsersList = async (): Promise<void> => {
      try {
        const response = await getClinicUsersList(groupId, clinicId);

        if (Array.isArray(response?.data)) {
          setGroupUsersList(response?.data);
        } else {
          setGroupUsersList([]);
        }
      } catch (error: any) {
        enqueueSnackbar(error && error?.message, SnackBarConfig('e'));
        throw error;
      }
    };

    fetchClinicUsersList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Dialog
      className={classes.wrapper}
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth={'md'}
      fullWidth
      open={showConversation}>
      <DialogContent dividers className={classes.dialogContentWrapper}>
        <MessagesConversation
          groupId={groupId}
          clinicId={clinicId}
          guarantorId={guarantorId}
          messageId={messageId}
          handleClose={handleClose}
          groupUsers={groupUsersList}
          defaultEventType={defaultEventType}
        />
      </DialogContent>
    </Dialog>
  );
};
export default MessagesConversationDialog;
